import { isArray, isObject } from 'helpers/global.helper/global.helper'
import getLogger from 'utils/log/log'

const log = getLogger('dbs.helper')

export function prefixReturnIdsForDbSDatasetInstruction(data: any, prefix: any): any {
  if (!prefix) {
    return data
  }

  if (isArray(data)) {
    return data.map((item: any) => prefixReturnIdsForDbSDatasetInstruction(item, prefix))
  }

  if (!isObject(data)) {
    return data
  }

  Object.keys(data).forEach((key) => {
    if (key === 'id_renaming') {
      let internalIds = data?.metadata_filter?.include?.internal_id || []
      if (typeof internalIds === 'string') {
        internalIds = [internalIds]
      }

      const uniqueInternalIds = Array.from(new Set(internalIds))

      const idRenaming = data?.id_renaming || {}
      uniqueInternalIds.forEach((internalId: any) => {
        let returnId = idRenaming[internalId] || internalId

        if (isArray(returnId)) {
          returnId = returnId.map((id) => `${prefix}${id}`)
          idRenaming[internalId] = returnId
        } else {
          returnId = `${prefix}${returnId}`
          idRenaming[internalId] = returnId
        }
      })

      data[key] = idRenaming
    } else {
      data[key] = prefixReturnIdsForDbSDatasetInstruction(data[key], prefix)
    }
  })

  return data
}

export function serializeMetadataFilter(
  metadataFilter:
    | {
        include: Record<string, string[] | string>
        exclude: Record<string, string[] | string>
      }
    | null
    | undefined
): { include: Record<string, string[]>; exclude: Record<string, string[]> } {
  const include = metadataFilter?.include || {}
  const exclude = metadataFilter?.exclude || {}

  // Make sure that all values are arrays and remove any empty arrays or values
  Object.entries(include).forEach(([key, values]) => {
    if (!isArray(values)) {
      values = [values as string]
      include[key] = values
    }

    include[key] = (values as string[])
      .filter((value) => value !== '' && value !== null && value !== undefined)
      .map((value) => String(value))

    const nrOfValues = include[key].length
    const uniqueValues = Array.from(new Set(include[key]))
    if (nrOfValues !== uniqueValues.length) {
      const duplicateValues = include[key].filter((value, index) => include[key].indexOf(value) !== index)

      log.warn(`DbS metadataFilter.include.${key} contains duplicate values: `, { metadataFilter, duplicateValues })
      include[key] = uniqueValues
    }
  })
  Object.entries(exclude).forEach(([key, values]) => {
    if (!isArray(values)) {
      exclude[key] = [values as string]
    }

    exclude[key] = (values as string[])
      .filter((value) => value !== '' && value !== null && value !== undefined)
      .map((value) => String(value))

    const nrOfValues = exclude[key].length
    const uniqueValues = Array.from(new Set(exclude[key]))
    if (nrOfValues !== uniqueValues.length) {
      const duplicateValues = exclude[key].filter((value, index) => exclude[key].indexOf(value) !== index)

      log.warn(`DbS metadataFilter.exclude.${key} contains duplicate values: `, { metadataFilter, duplicateValues })
      exclude[key] = uniqueValues
    }
  })

  return { include, exclude } as { include: Record<string, string[]>; exclude: Record<string, string[]> }
}
